import { ChevronLeftIcon } from '~components/icons'
import { ButtonHTMLAttributes } from 'react'
import { COLORS, SPACINGS } from './theme'

import { Button as TextButton } from '@mui/material'
// eslint-disable-next-line
import styled, { css } from 'styled-components'

export interface NavigationButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  ariaLabel?: string
  className?: string
  disabled?: boolean
  variant: 'left' | 'right'
  text?: string
}

const StyledButton = styled.button<{
  variant: 'left' | 'right'
}>`
  align-items: center;
  appearance: none;
  background-color: ${COLORS.greys.ultraLight};
  border: 0px;
  box-sizing: border-box;
  cursor: pointer;
  display: inline-flex;
  flex: 0 0 auto;
  justify-content: center;
  margin: 0px;
  outline: 0px;
  overflow: visible;
  width: ${SPACINGS[4]};
  height: ${SPACINGS[4]};
  position: relative;
  text-align: center;
  text-decoration: none;
  transition: background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  user-select: none;
  vertical-align: middle;

  > svg {
    transform: ${({ variant }) =>
      variant === 'right' ? 'rotate(180deg)' : 'initial'};
  }
  &:hover {
    background-color: ${COLORS.secondary.lightBlue.tint};
  }

  &:focus-visible {
    outline: 2px solid ${COLORS.greys.light};
  }

  &:active {
    background-color: ${COLORS.greys.light};
  }

  &:disabled {
    background-color: ${COLORS.greys.ultraLight};
    pointer-events: none;
  }
`

const StyledTextButton = styled(TextButton)<{ alignment: 'left' | 'right' }>`
  ${({ alignment }) =>
    alignment === 'right' &&
    css`
      flex-direction: row-reverse;
      gap: 0.5rem;
      > span svg {
        transform: rotate(180deg);
      }
    `}
`

export function NavigationButton({
  ariaLabel,
  className,
  text,
  disabled,
  variant,
  ...props
}: NavigationButtonProps) {
  return text ? (
    // @ts-ignore
    <StyledTextButton
      alignment={variant}
      disabled={disabled}
      startIcon={<ChevronLeftIcon size={20} />}
      {...props}
    >
      {text}
    </StyledTextButton>
  ) : (
    <StyledButton
      variant={variant}
      aria-label={ariaLabel}
      className={className}
      disabled={disabled}
      {...props}
    >
      <ChevronLeftIcon size={20} />
    </StyledButton>
  )
}

NavigationButton.displayName = 'NavigationButton'

export default NavigationButton
